module.exports = __webpack_public_path__ + "static/media/rede-protecao-3.a75953cc.png";